/* eslint no-undef: 0 */
import React from 'react'
import { observable, action } from 'mobx'
import * as linkConst from '../../constants/link_constants'
import * as defaultConst from '../../constants/default_constants'
import { BaseTableState } from './base'

export default (store) => {
  // -- list view --
  class TableState extends BaseTableState {
    attrs = [
      'id', 'entity'
    ]

    headertitles = [
      store.__('ID'), store.__('entity')
    ]

    title = store.__('archived items')

    init () {
      store.options.get('entityname').forEach(i => {
        if (linkConst.ARCHIVE_LINKS_ONLY[i.value]) {
          i.value = linkConst.ARCHIVE_LINKS_ONLY[i.value]
        }
      })

      return super.init()
    }
  }

  // -- detail view --
  class ManipState {
    constructor (store) {
      this.store = store
    }

    @observable data = null
    @observable dataInfo = null
    @observable detail = null
    @observable detailLoad = null

    actions = {
      c: store.__('create'),
      u: store.__('update'),
      d: store.__('delete')
    }

    load (entity, id) {
      this.store.cv.title = (
        <h4 className='card-title'>
          { linkConst.LINK_ARCHIVE_TITLE.concat(defaultConst.TITLE_DIVIDER) +
           (linkConst.LINKS_LIST[entity] || linkConst.ARCHIVE_LINKS_TITLES[entity] || entity)
          }
          <span className='header-id'>#{id}</span>
        </h4>
      )
      this.store.requester.call(`/${linkConst.LINK_ARCHIVE}/${entity}/${id}`)
        .then(found => {
          this.data = found.data
        })
    }

    @action showDetail (row) {
      const values = this.data[this.data.indexOf(row)]
      this.dataInfo = {
        key: this.data.indexOf(row),
        value: {
          created: moment(values.created).utc().format(defaultConst.DATE_FORMAT_FULL),
          action: this.actions[values.action],
          user: values.user.replace('.json', '')
        }
      }
      const r = this.store.router.params
      const entityname = r.eid ? linkConst.LINK_CONTRACT_ITEMS : r.entityname
      const key = `${entityname}_${r.id}/${row.action}_${row.created}_${row.user}`
      this.store.requester
        .call(`/archive/detail/${key}`)
        .then(action(res => {
          this.detailLoad = null
          this.detail = res.data
        })).catch(err => {
          this.detailLoad = null
          store.addMessage && store.addMessage((err.message || err), 'error')
        })
    }

    @action hideDetail () {
      this.detail = null
      this.detailLoad = null
    }

    @action restore (row) {
      const answer = confirm('really restore this record?')
      if (!answer) { return }
      const r = this.store.router.params
      const key = `${r.entityname}_${r.id}/${row.action}_${row.created}_${row.user}`
      this.store.requester
        .call(`/archive/restore/${key}`, 'put')
        .then(action(res => {
          store.addMessage('restored sucessfully')
        }))
        .catch(action(err => {
          this.detailLoad = null
          store.addMessage && store.addMessage((err.message || err), 'error')
        }))
    }

    canRestore (row) {
      return row.action === 'd' && this.store.router.params.entityname !== 'cntrimts'
    }

    headertitles = [
      ' ', store.__('created'), store.__('action'), store.__('user')
    ]

    title = store.__(linkConst.LINK_ARCHIVE_TITLE)
  }

  return { ManipState, TableState }
}
